import global from "./global.json";

export const de = {
  global,
};
